export const RESET_ERRORS = 'app/creditCards/REPLACE_CREDIT_CARD_INIT'

export interface ResetErrorsAction {
  type: typeof RESET_ERRORS
}

export type AccountSettingsActions = ResetErrorsAction

export const createResetErrorsAction = (): ResetErrorsAction => ({
  type: RESET_ERRORS,
})
